import { Component, OnInit, Input } from '@angular/core';
import { closeModal } from '../../../shared/modal-functions';
import { subscriptionViewSpanish } from '../../subscription/subscription.static.data';

@Component({
  selector: 'app-response-help',
  templateUrl: './response-help.component.html',
  styleUrls: ['../../../app.component.css']
})
export class ResponseHelpComponent implements OnInit {
  subscriptionView: any;
  closeModal: any;
  @Input() 
  modalTitle: string;
  @Input() 
  modalBody: string;

  constructor() { 
    this.subscriptionView = subscriptionViewSpanish;
    this.closeModal = closeModal;
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/help/response-help/response-help.component.ts